module.exports = __webpack_public_path__ + "static/media/11_l_golova_22.4_82.78.c788a347.png";